// extracted by mini-css-extract-plugin
module.exports = {"divider":"language-switcher_divider__E_HPi","label":"language-switcher_label__Iwnh_","labelActive":"language-switcher_labelActive__Dv8uK"};